import type { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { GlobalLoginProvider } from '@repo/global-login-sdk/react';
import { Toaster } from '@repo/ui/components/ui/sonner';
import { queryClient, supabase } from '@shared/api';
import { globalLoginConfig } from '@shared/config';

/**
 * Bündelt die globalen Provider der Admin-App: TanStack Query (Server-State),
 * den `GlobalLoginProvider` (zentrale Session + SDK-Config) und den globalen
 * Sonner-`Toaster` (sonst zeigen die `toast.*`-Aufrufe der Features nichts an).
 * Wird einmalig um den Router gelegt.
 *
 * @param props.children Der zu umschließende App-Baum (Router).
 * @returns Der mit allen Providern umschlossene Baum.
 */
export function AppProviders({ children }: { children: ReactNode }): ReactNode {
  return (
    <QueryClientProvider client={queryClient}>
      <GlobalLoginProvider client={supabase} config={globalLoginConfig}>
        {children}
        <Toaster position="bottom-right" />
      </GlobalLoginProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
